import script from "./ModalInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalInput.vue?vue&type=script&setup=true&lang=js"

import "./ModalInput.vue?vue&type=style&index=0&id=40eee270&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40eee270"]])

export default __exports__